import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

Vue.use(Vuex);

const state = {
  auth: null,
  lastSignupStep: 1,
  landingURL: '',
  newCampaignId: null,
  isMenuMinimized: false,
  company: {
    id: 0,
    companyName: '',
    description: '',
    website: '',
    address: '',
    currency: '',
    status: true,
  },
  campaign: {
    widget: {},
  },
  companyBalances: [],
  isWhiteLabel: false,
};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
});



// WEBPACK FOOTER //
// ./src/store/index.js